import moment from 'moment'
import { create } from 'zustand'

import { FILTER_DEFAULT_SKIP, FILTER_DEFAULT_TAKE } from '@apps-common/config/filter'

// const PORTAL_ORDER_FILTER_DEFAULT_START_DATE = '2020-01-01T00:00:00'
// const PORTAL_ORDER_FILTER_DEFAULT_END_DATE = moment().add(2, 'days').toISOString()

export const getPortalOrderFilterDefaultStartDateStr = () => '2000-01-01T00:00:00'
export const getPortalOrderFilterDefaultEndDateStr = () => moment().add(1, 'day').toISOString()

//  Status
//  CompanyId
//  OrderNo
//  StartDate
//  EndDate
//  Skip
//  Take

export const DEFAULT_PORTAL_ORDER_FILTER_STORE_PROPS: IPortalOrderFilterProps = {
  status: '',
  companyId: '',
  orderNo: '',
  startDate: null,
  endDate: null,
  skip: FILTER_DEFAULT_SKIP,
  take: FILTER_DEFAULT_TAKE
}

export interface IPortalOrderFilterProps {
  status: string
  companyId: string
  orderNo: string
  startDate: string | null
  endDate: string | null
  skip: number
  take: number
}

interface IPortalOrderFilterStore extends IPortalOrderFilterProps {
  setStatus: (value: string) => void
  setCompanyId: (value: string) => void
  setOrderNo: (value: string) => void
  setStartDate: (value: string) => void
  setEndDate: (value: string) => void
  setSkip: (value: number) => void
  setTake: (value: number) => void
  getSearchParams: () => IPortalOrderFilterProps
  getFilteredByKeywords: () => string[]
  clear: () => void
}

export const usePortalOrderFilterStore = create<IPortalOrderFilterStore>((set, get) => ({
  ...DEFAULT_PORTAL_ORDER_FILTER_STORE_PROPS,
  setStatus: (value: string) => {
    const { status } = get()

    if (status !== value) {
      set(() => ({ status: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setCompanyId: (value: string) => {
    const { companyId } = get()

    if (companyId !== value) {
      set(() => ({ companyId: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setOrderNo: (value: string) => {
    const { orderNo } = get()

    if (orderNo !== value) {
      set(() => ({ orderNo: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setStartDate: (value: string) => {
    const { startDate } = get()

    if (startDate !== value) {
      set(() => ({ startDate: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setEndDate: (value: string) => {
    const { endDate } = get()

    if (endDate !== value) {
      set(() => ({ endDate: value, skip: FILTER_DEFAULT_SKIP }))
    }
  },
  setSkip: (value: number) => set(() => ({ skip: value })),
  setTake: (value: number) => set(() => ({ take: value })),
  getSearchParams: () => {
    const { status, orderNo, companyId, startDate, endDate, skip, take } = get()

    return {
      status,
      orderNo,
      companyId,
      startDate,
      endDate,
      skip,
      take
    }
  },
  getFilteredByKeywords: () => {
    const { status, orderNo, companyId, startDate, endDate, skip, take } = get()

    const keywords = []

    if (status !== '') {
      keywords.push('Status')
    }

    if (orderNo !== '') {
      keywords.push('Order#')
    }

    if (companyId !== '') {
      keywords.push('Company')
    }

    if (!!startDate || !!endDate) {
      keywords.push('Date')
    }

    return keywords
  },
  clear: () => {
    set(() => ({
      ...DEFAULT_PORTAL_ORDER_FILTER_STORE_PROPS
    }))
  }
}))
